import Vue from 'vue'
import * as api from '../services/api'
import * as blockui from '../../helpers/block-ui'
import * as dateFormat from '../../helpers/dateFormat'
import grid from '../global/gridOld'

export default {
  data() {
    return {
      IsReady: true,
      gridEngine: undefined,
      data: [],
      columns: [
        {
          type: 'rownumber',
          field: 'rownumber',
          locked: true,
          tooltipRenderer: false,
        },
        {
          field: 'staff',
          text: 'Staff',
          width: 200,
          locked: true,
          tooltipRenderer: false,
        },
        {
          field: 'role',
          text: 'Role',
          width: 200,
          locked: true,
          hidden: true,
          tooltipRenderer: false,
        },
        {
          type: 'number',
          field: 'requiredTraining',
          text: 'Required Training',
          width: 170,
          align: 'center',
          locked: true,
          tooltipRenderer: false,
          htmlEncode: false,
          renderer: ({ record, value }) => `<b ${!record.isTrained ? 'style="color:red"' : ''}>${value}</b>`,
        },
      ],
      group: 'role',
    }
  },
  components: {
    grid,
  },
  async created() {},
  methods: {
    initGrid() {
      const self = this
      self.gridEngine = self.$refs.grid.gridEngine

      function getTextWidth(text, font) {
        const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement('canvas'))
        const context = canvas.getContext('2d')
        context.font = font
        const metrics = context.measureText(text)
        return metrics.width
      }

      // Hücrelerde eğitim adından uzun olabilen metinli ifadeler gösterildiği için
      // kolon genişliği yalnızca başlığa göre değil, en uzun ifadeye göre de hesaplanır.
      const minCellWidth =
        Math.max(
          ...[self.translate('training_completed'), self.translate('training_not_completed_yet')].map((label) =>
            getTextWidth(label, '700 11px Roboto, sans-serif')
          )
        ) + 30

      const groupedCols = []
      self.gridEngine.columns.forEach((col) => {
        if (col.id.includes('col')) groupedCols.push(col)
      })
      groupedCols.forEach((groupedCol) => {
        let total = 0
        groupedCol.children.forEach((col) => {
          col.width = Math.max(getTextWidth(col.text, '500 11px Roboto, sans-serif') + 30, minCellWidth)
          total += col.width
        })

        const headerWidth = getTextWidth(groupedCol.text, '500 11px Roboto, sans-serif') + 15
        if (headerWidth > total) {
          const increment = (headerWidth - total) / groupedCol.children.length
          groupedCol.children.forEach((col) => (col.width += increment))
        }
      })
    },
    clearAll() {
      this.IsReady = false
      this.gridEngine = undefined
      this.data = []
      this.columns = [
        {
          type: 'rownumber',
          field: 'rownumber',
          locked: true,
          tooltipRenderer: false,
        },
        {
          field: 'staff',
          text: 'Staff',
          width: 200,
          locked: true,
          tooltipRenderer: false,
        },
        {
          field: 'role',
          text: 'Role',
          width: 200,
          locked: true,
          hidden: true,
          tooltipRenderer: false,
        },
        {
          type: 'number',
          field: 'requiredTraining',
          text: 'Required Training',
          width: 170,
          align: 'center',
          locked: true,
          tooltipRenderer: false,
          htmlEncode: false,
          // renderer: ({ record, value }) => `<b style="color: ${!record.isTrained ? 'red' : 'inherit'};">${value}</b>`,
          renderer: ({ record, value }) => `<b style="color: ${!record.isTrained ? 'red' : 'red'};">${value}</b>`,
        },
      ]
      this.group = 'role'
    },
    async getResources() {
      const self = this
      let untbgtltDay = self.$route.query.usersNeedToBeGetTrainingLessThanDays
      untbgtltDay = untbgtltDay && untbgtltDay > 0 ? untbgtltDay : 5
      await api.getTrainingDemands({ daysToCheck: untbgtltDay, isUser: true }).then(
        (res) => {
          self.data = res.body.Data.map((item) => ({
            id: item.Id,
            staff: item.Name,
            role: item.ParentName,
            roleId: item.ParentId,
            requiredTraining: item.Total,
            isTrained: !item.IsUntrained,
          }))
        },
        (error) => {}
      )
    },
    async appendData() {
      const self = this
      await api.getLastTrainingsForUsers().then(
        (res) => {
          res.body.Data.forEach((item) => {
            const row = self.data.find((x) => x.id === item.UserId)
            if (!row) return

            row[`trainingExpireDate${item.TrainingId}`] = item.ExpireDate
            row[`trainingIssueDate${item.TrainingId}`] = item.IssueDate
            row[`trainingDuration${item.TrainingId}`] = item.Duration
            row[`trainingIsValid${item.TrainingId}`] = item.IsValid

            // Duration null: rolün bu eğitimi almasına gerek yok, kalan gün alanı hiç doldurulmaz ('-').
            if (item.Duration == null) return

            // Eğitimin alınıp alınmadığı IssueDate'ten anlaşılır; RemainingDay eğitim bugün
            // alındığında 0 döndüğü için truthiness kontrolü yapılamaz.
            if (item.Duration === 0) {
              // Bir kez alınması gereken eğitim: süre dolması diye bir durum yok.
              row[`trainingRemainingDay${item.TrainingId}`] = item.IssueDate
                ? Number.POSITIVE_INFINITY
                : Number.NEGATIVE_INFINITY
            } else {
              // Periyodik eğitim: alınmadıysa kalan gün hesaplanamaz.
              row[`trainingRemainingDay${item.TrainingId}`] =
                item.IssueDate == null ? Number.NEGATIVE_INFINITY : item.RemainingDay
            }
          })
        },
        (error) => {}
      )
    },
    async appendTrainings() {
      const self = this
      await api.getTrainingList().then(
        async (res) => {
          let trainingList = res.body.Data
          const tntbeltDay = self.$route.query.trainingNeedToBeEnrolledLessThanDays
          if (tntbeltDay && tntbeltDay > 0) {
            const response = (
              await api.getTrainingDemands({
                daysToCheck: tntbeltDay,
                isUser: false,
              })
            ).body.Data
            const filterData = response
              .filter((item) => item.Total > 0)
              .map((item) => ({
                id: item.Id,
                staff: item.Name,
                trainingType: item.ParentName,
                trainingTypeId: item.ParentId,
                total: item.Total,
              }))

            trainingList = trainingList.filter((training) => !!filterData.find((x) => x.id == training.Id))
          }

          trainingList.forEach((item) => {
            if (!self.columns.some((x) => x.text === item.TrainingType.Name)) {
              self.columns.push({
                text: item.TrainingType.Name,
                children: [],
                filterable: false,
              })
            }
            self.columns
              .filter((x) => x.text === item.TrainingType.Name)[0]
              .children.push({
                type: 'number',
                field: `trainingRemainingDay${item.Id}`,
                text: item.Name,
                groupable: false,
                htmlEncode: false,
                draggable: false,
                renderer: ({ record }) => {
                  const remainingDay = record.data[`trainingRemainingDay${item.Id}`]
                  const isValid = record.data[`trainingIsValid${item.Id}`]
                  // Eğitim gerekmiyor.
                  if (remainingDay == null) {
                    return '<b>-</b>'
                  }
                  // Bir kez alınması gereken eğitim alınmış.
                  if (remainingDay === Number.POSITIVE_INFINITY) {
                    return `<b>${self.translate('training_completed')}</b>`
                  }
                  // Eğitim gerekiyor ama hiç alınmamış.
                  if (remainingDay === Number.NEGATIVE_INFINITY) {
                    return `<b style="color:red">${self.translate('training_not_completed_yet')}</b>`
                  }
                  return `<b ${!isValid ? 'style="color:red"' : ''}>${remainingDay}</b>`
                },
                tooltipRenderer: ({ record }) => {
                  if (!Number.isInteger(record.id)) return
                  const remainingDayValue = record.data[`trainingRemainingDay${item.Id}`]
                  const durationValue = record.data[`trainingDuration${item.Id}`]
                  let expireDate = record.data[`trainingExpireDate${item.Id}`]
                  let issueDate = record.data[`trainingIssueDate${item.Id}`]
                  // Eğitim gerekmiyorsa veya bir kez alınıp tamamlandıysa kırmızıya boyanmaz.
                  const color =
                    record.data[`trainingIsValid${item.Id}`] ||
                    remainingDayValue == null ||
                    remainingDayValue === Number.POSITIVE_INFINITY
                      ? 'white'
                      : 'red'
                  expireDate = expireDate ? dateFormat.viewDateFormat(expireDate) : ''
                  issueDate = issueDate ? dateFormat.viewDateFormat(issueDate) : ''
                  const remainingDay =
                    remainingDayValue == null
                      ? '-'
                      : remainingDayValue === Number.NEGATIVE_INFINITY
                      ? self.translate('training_not_completed_yet')
                      : remainingDayValue === Number.POSITIVE_INFINITY
                      ? self.translate('training_completed')
                      : remainingDayValue
                  const duration =
                    durationValue == null
                      ? self.translate('training_not_required')
                      : durationValue === 0
                      ? self.translate('training_once')
                      : `${durationValue} ${self.translate('month')}`

                  return `<div>${self.translate(
                    'training_duration_empty'
                  )}:\xa0<b>${duration}</b><div></div>${self.translate(
                    'remaining_days'
                  )}:\xa0<b style="color:${color}">${remainingDay}</b><div></div>${self.translate(
                    'issue_date'
                  )}:\xa0<b style="color:${color}">${issueDate}</b><div></div>${self.translate(
                    'expire_date'
                  )}:\xa0<b style="color:${color}">${expireDate}</b>`
                },
              })
          })
        },
        (error) => {}
      )
    },
  },
  async mounted() {
    this.clearAll()
    const self = this
    blockui.pageBlock(self)
    await self.getResources()
    await self.appendTrainings()
    await self.appendData()

    blockui.unBlockPage()
    self.IsReady = true
  },
  unmounted() {
    this.clearAll()
  },
}
